import type { Theme } from "@mui/material/styles";

export const footerRoot = (theme: Theme) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  width: "100%",
  backgroundColor: theme.palette.common.white,
  zIndex: theme.zIndex.appBar,

  // less tall; feels like a footer again
  height: "clamp(64px, 5vw, 88px)",
  padding: "0 24px",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
});

export const footerLinkRowSx = {
  height: "100%",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "15px",

  color: "inherit",
  textDecoration: "none",
};

export const footerTextOneLineSx = {
  fontSize: "1.05rem",         // “increase text size some”
  lineHeight: 1.2,
  whiteSpace: "nowrap",        // one line on desktop
  overflow: "hidden",
  textOverflow: "ellipsis",    // if someone’s screen is small, it won’t explode
  flex: "1 1 auto",

  "@media (max-width: 900px)": {
    whiteSpace: "normal",      // wrap on mobile
    fontSize: "0.95rem",
  },
};

export const logoPunctSx = {
  height: "42px",              // punctuation-sized, not dominating
  width: "auto",
  objectFit: "contain",
  flex: "0 0 auto",
  display: "block",
};
